module.exports = __webpack_public_path__ + "img/ico-edit.2ba08c1c.svg";